// Module
var code = "<login *ngIf=\"!isNewLoginEnabled\"></login> <new-login *ngIf=\"isNewLoginEnabled\"></new-login> ";
// Exports
module.exports = code;